import { useCallback } from 'react'
import { TALENTPROFILE } from '../../../constants/evaluation-types'
import trackEvents from '../../../constants/track-events'
import { query } from '../../../graphql'
import { notifyBugsnag } from '../../../helpers'
import { trackEvent } from '../../../helpers/analytics'
import { openPdfLoadingWindow } from '../../../helpers/pdf-loading'
import { useTalentStorage } from '../../pricing/hooks'
import {
  LIMIT_DIALOG_ACTIONS,
  usePricingDialog
} from '../../pricing/pricing-dialog-context'

/**
 * Talentprofil als PDF. spaceId ist der Space aus der Auswahl, für ihn und
 * für die Person (talentOwner) wird der Talentspeicher geprüft. Gesperrt gibt
 * es kein PDF, solange nicht gezählt ist, ebenfalls nicht.
 */
export function useTalentProfileDownload({
  talentOwner,
  spaceId,
  language,
  t,
  onSuccess,
  onError
}) {
  const { pending, isLocked, isPendingId, isOwnerLocked, isPendingOwner } =
    useTalentStorage({ fetch: 'auto' })
  const { openLimitDialog } = usePricingDialog()

  return useCallback(async () => {
    // Gesperrt wird je Person, das PDF lädt am owner
    if (
      isLocked(spaceId) ||
      (!!talentOwner && !!isOwnerLocked?.(talentOwner))
    ) {
      if (
        !pending &&
        !isPendingId?.(spaceId) &&
        !(talentOwner && isPendingOwner?.(talentOwner))
      ) {
        openLimitDialog('talentStorage', {
          action: LIMIT_DIALOG_ACTIONS.INFO,
          source: 'discover_talent_profile_pdf'
        })
      }
      return
    }

    if (!talentOwner) {
      onError?.()
      notifyBugsnag(new Error('Missing talent owner'))
      return
    }

    const pdfDocument = openPdfLoadingWindow({ t, language })

    try {
      const response = await query({
        query: 'generatePdf',
        variables: { user_id: talentOwner, language, type: TALENTPROFILE }
      })

      const location = JSON.parse(response)?.headers?.Location
      if (!location) throw new Error('Missing PDF location')

      pdfDocument
        ? (pdfDocument.location.href = location)
        : window?.open(location, '_blank')
      onSuccess?.(t('pdf_success'))
      trackEvent(trackEvents.VIEW_STRENGTH_PROFILE_V2)
    } catch (err) {
      onError?.()
      notifyBugsnag(err)
      pdfDocument?.close()
    }
  }, [
    language,
    onError,
    onSuccess,
    talentOwner,
    t,
    spaceId,
    isLocked,
    isPendingId,
    isOwnerLocked,
    isPendingOwner,
    pending,
    openLimitDialog
  ])
}
